import { NOTIFICATION_VARIABLES } from "data/constants";

/**
 * return count of unread notifications
 * @param {Array} allNotifications
 * @return {number} - unReadNotifications.length
 */

export const unReadNotificationsCount = (allNotifications: any) => {
  if (allNotifications?.length > 0) {
    const unReadNotifications = allNotifications.filter(
      (notification: any) => notification.status !== NOTIFICATION_VARIABLES.read
    );

    return unReadNotifications.length;
  }
  return 0;
};
